import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../api';

const ActivateAccountPage = () => {
  const { uid, token } = useParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("アカウントを有効化しています...");

  useEffect(() => {
    // 認証API呼び出し
    api.get(`accounts/activate/${uid}/${token}/`)
      .then(() => {
        setMessage("アカウントが有効化されました。ログイン画面へリダイレクトします。");
        setTimeout(() => {
          navigate("/customer/login?activated=true");
        }, 2000); // 2秒後にログイン画面へ
      })
      .catch(() => {
        setMessage("アカウントの有効化に失敗しました。すでに認証済みか、リンクが無効です。");
      });
  }, [uid, token, navigate]);

  return <div style={{ padding: 40 }}>{message}</div>;
};

export default ActivateAccountPage;